<template>
    <div class="accounting-detail-data accounting-petty-money-detail">
        <div class="detail-container">
            <div class="detail-section">
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item vertical">
                        <div class="label">摘要</div>
                        <div class="value xl b">
                            <span>零用現金</span>
                            <span v-if="documentDetail.typ === 1">轉入</span>
                            <span v-if="documentDetail.typ === 2">轉出</span>
                        </div>
                    </div>
                </div>
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item">
                        <div class="label">系統單號</div>
                        <div class="value">
                            <el-button type="text" @click="openPettyCashDetail(documentDetail)">{{ documentDetail.systemNo }}</el-button>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">帳務日期</div>
                        <div class="value">{{ documentDetail.dat | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">
                            <span v-if="documentDetail.typ === 1">轉入</span>
                            <span v-if="documentDetail.typ === 2">轉出</span>
                            <span>金額</span>
                        </div>
                        <div class="value xl"><Money :v="documentDetail.amt" /><span class="cny">TWD</span></div>
                    </div>
                    <div class="item" v-if="documentDetail.bankName">
                        <div class="label">
                            <span v-if="documentDetail.typ === 1">扣款</span>
                            <span v-if="documentDetail.typ === 2">入帳</span>
                            <span>帳戶</span>
                        </div>
                        <div class="value">{{ documentDetail.bankName }}</div>
                    </div>
                    <div class="item">
                        <div class="label">備註</div>
                        <div class="value">{{ documentDetail.mem || "--" }}</div>
                    </div>
                </div>
            </div>
        </div>
        <PettyCashDetailDialog :visible="pettyCashDetailDialog.visible" :data="pettyCashDetailDialog.data" @close="handlePettyCashDetailDialogClose" />
    </div>
</template>

<script>
export default {
    props: {
        queryType: {
            type: Number,
            default: null,
        },
        datas: {
            type: Object,
            default: () => {},
        },
    },
    components: { PettyCashDetailDialog: () => import('@/components/dashboard/Finance/PettyCash/DetailDialog.vue') },
    data() {
        return {
            currentPage: 1,
            pettyCashDetailDialog: {
                visible: false,
                sno: null,
            },
            bankAccountList: [],
        };
    },
    created() {},
    computed: {
        documentDetail() {
            return this.datas.detail || {};
        },
        firstProjectPoo() {
            return this.documentDetail.projects[0]?.poo;
        },
    },
    methods: {
        openPettyCashDetail(data) {
            this.pettyCashDetailDialog.data = data;
            this.pettyCashDetailDialog.visible = true;
        },
        handlePettyCashDetailDialogClose(refresh) {
            this.$emit('detailClose', refresh);
            this.pettyCashDetailDialog.visible = false;
            this.pettyCashDetailDialog.sno = null;
        },
    },
};
</script>

<style lang="scss">
.accounting-petty-money-detail {
}
</style>
